import { delay, filter, first, map, switchMap, tap } from 'rxjs/operators';
import { filterFirst } from 'ngx-unificator/rxjs';
import { computed, inject, Injectable, signal } from '@angular/core';
import { PlatformService, WindowService } from 'ngx-unificator/services';
import { StaticContentService } from './static-content.service';
import { UserService } from './user/user.service';
import { ScriptLoaderService } from './script-loader.service';
import { GroupsService } from './groups.service';
import { of } from 'rxjs';

const NOVATRIX_STATIC_SLUG = 'novatrix-seal-id';

@Injectable({providedIn: 'root'})
export class NovatrixService {
  private _platform = inject(PlatformService);
  private _static = inject(StaticContentService);
  private _user = inject(UserService);
  private _scriptLoader = inject(ScriptLoaderService);
  private _group = inject(GroupsService);
  private _window = inject(WindowService);

  public novatrixSealId = signal('');

  public novatrixScriptUrl = computed(() => `https://${this.novatrixSealId()}.seals.dlagglobal.com/dlag-seal.js`);

  public novatrixDlagInitVariable = computed(() => `dlag_${this.novatrixSealId()}`.replace(/-/g, '_'));

  public novatrixDlagAttrId = computed(() => `dlag-${this.novatrixSealId()}`);

  /**
   * Init Novatrix
   */
  public initNovatrix() {
    if (this._platform.isBrowser) {
      this._user.auth$.pipe(
        filter(auth => !!auth && this._group.isExistGroup('novatrix')),
        first(),
        switchMap(() => !this.novatrixSealId() ? this._static.item({slug: NOVATRIX_STATIC_SLUG}) : of([{Content: this.novatrixSealId()}])),
        filterFirst(data => !!data),
        map(data => data?.[0]?.Content),
        filter(sealId => !!sealId),
        tap(sealId => this.novatrixSealId.set(sealId)),
        switchMap(() => this._scriptLoader.load(this.novatrixScriptUrl())),
        delay(500),
        filter(() => this._window.nativeWindow[this.novatrixDlagInitVariable()]),
        tap(() => this._window.nativeWindow[this.novatrixDlagInitVariable()]?.init()),
      ).subscribe();
    }
  }
}
